/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PaymentMethodDto } from './PaymentMethodDto';
import {
    PaymentMethodDtoFromJSON,
    PaymentMethodDtoFromJSONTyped,
    PaymentMethodDtoToJSON,
} from './PaymentMethodDto';

/**
 * 
 * @export
 * @interface PayByAmountDigitalBillDto
 */
export interface PayByAmountDigitalBillDto {
    /**
     * 
     * @type {number}
     * @memberof PayByAmountDigitalBillDto
     */
    amount: number;
    /**
     * 
     * @type {PaymentMethodDto}
     * @memberof PayByAmountDigitalBillDto
     */
    paymentMethod: PaymentMethodDto;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof PayByAmountDigitalBillDto
     */
    orderLineQuantityMap?: { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof PayByAmountDigitalBillDto
     */
    tipAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof PayByAmountDigitalBillDto
     */
    discountCode?: string;
    /**
     * 
     * @type {number}
     * @memberof PayByAmountDigitalBillDto
     */
    serviceChargePercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof PayByAmountDigitalBillDto
     */
    placementId?: number;
    /**
     * 
     * @type {string}
     * @memberof PayByAmountDigitalBillDto
     */
    deviceId: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PayByAmountDigitalBillDto
     */
    dynamicFields?: { [key: string]: string; };
}

/**
 * Check if a given object implements the PayByAmountDigitalBillDto interface.
 */
export function instanceOfPayByAmountDigitalBillDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "amount" in value;
    isInstance = isInstance && "paymentMethod" in value;
    isInstance = isInstance && "deviceId" in value;

    return isInstance;
}

export function PayByAmountDigitalBillDtoFromJSON(json: any): PayByAmountDigitalBillDto {
    return PayByAmountDigitalBillDtoFromJSONTyped(json, false);
}

export function PayByAmountDigitalBillDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PayByAmountDigitalBillDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'amount': json['amount'],
        'paymentMethod': PaymentMethodDtoFromJSON(json['paymentMethod']),
        'orderLineQuantityMap': !exists(json, 'orderLineQuantityMap') ? undefined : json['orderLineQuantityMap'],
        'tipAmount': !exists(json, 'tipAmount') ? undefined : json['tipAmount'],
        'discountCode': !exists(json, 'discountCode') ? undefined : json['discountCode'],
        'serviceChargePercentage': !exists(json, 'serviceChargePercentage') ? undefined : json['serviceChargePercentage'],
        'placementId': !exists(json, 'placementId') ? undefined : json['placementId'],
        'deviceId': json['deviceId'],
        'dynamicFields': !exists(json, 'dynamicFields') ? undefined : json['dynamicFields'],
    };
}

export function PayByAmountDigitalBillDtoToJSON(value?: PayByAmountDigitalBillDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'amount': value.amount,
        'paymentMethod': PaymentMethodDtoToJSON(value.paymentMethod),
        'orderLineQuantityMap': value.orderLineQuantityMap,
        'tipAmount': value.tipAmount,
        'discountCode': value.discountCode,
        'serviceChargePercentage': value.serviceChargePercentage,
        'placementId': value.placementId,
        'deviceId': value.deviceId,
        'dynamicFields': value.dynamicFields,
    };
}

